export default "__VITE_ASSET__a43f84bf__"